const addZero = (input) => {
  input = input > 9 ? input : `0${input}`;
  return input;
};

export const getDateFormat = (input) => {
  input = new Date(input);
  let day = input.getDate();
  let month = input.getMonth() + 1;
  const year = input.getFullYear();
  return `${year}-${addZero(month)}-${addZero(day)}`;
};

export const getDateTimeFormat = (input) => {
  input = new Date(input);
  let day = input.getDate();
  let month = input.getMonth() + 1;
  const year = input.getFullYear();

  let hour = input.getHours();
  let minute = input.getMinutes();

  return `${year}-${addZero(month)}-${addZero(day)} ${addZero(hour)}:${addZero(
    minute
  )}`;
};

export const getDateFormat2 = (input, withTime) => {
  withTime = withTime ? withTime : false;

  const MONTH = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  input = new Date(input);
  let day = input.getDate();
  let month = input.getMonth();
  const year = input.getFullYear();

  if (!withTime) return `${day} ${MONTH[month]} ${year}`;

  let hour = input.getHours();
  let minute = input.getMinutes();

  return `${day} ${MONTH[month]} ${year} ${addZero(hour)}:${addZero(minute)}`;
};

export const validateEmail = (email) => {
  let isValidEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return isValidEmail.test(String(email).toLowerCase());
};

export const getInitial = (name) => {
  let initial = name || "";
  initial = initial.trim();
  initial = initial.split(" ");
  initial =
    initial.length > 1
      ? `${initial[0][0]}${initial[1][0]}`
      : `${initial[0][0]}`;
  return initial;
};

export const calculateAge = (birthday) => {
  if (birthday === undefined) return "";
  birthday = new Date(birthday);
  let ageDifMs = Date.now() - birthday.getTime();
  let ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const getPercPrediction = (base, val) => {
  let result = (val / base) * 100;
  return Math.round(result * 100) / 100;
};

export const formatter = new Intl.NumberFormat("id-ID", {});

export const generateGraphData = (inputDate, data) => {
  let result = new Array(7).fill("").map(() => ({
    _id: getDateFormat(inputDate.setDate(inputDate.getDate() + 1)),
    count: 0,
  }));
  data.forEach((res) => {
    const idx = result.findIndex((data) => data._id === res._id);
    if (idx >= 0) result[idx]["count"] = res["count"];
  });
  return result;
};

export const getDuration = (inputDate) => {
  let diff = (new Date() - inputDate) / 1000;
  const minutes = Math.floor(diff / 60) % 60;
  diff -= minutes * 60;
  const seconds = Math.floor(diff % 60);
  return `${addZero(minutes)}:${addZero(seconds)}`;
};

export const dbmToPercentage = (dBm) => {
  const RSSI_MAX = -50;
  const RSSI_MIN = -100;
  let quality;
  if (dBm <= RSSI_MIN) {
    quality = 0;
  } else if (dBm >= RSSI_MAX) {
    quality = 100;
  } else {
    quality = 2 * (dBm + 100);
  }
  return quality;
};

export const getSignalLabel = (percentage) => {
  let label;
  if (percentage >= 75) {
    label = "sangat kuat";
  } else if (percentage >= 50) {
    label = "kuat";
  } else if (percentage >= 25) {
    label = "lemah";
  } else {
    label = "sangat lemah";
  }
  return label;
};
